import React from "react";
import "./Nav.css"
import { NavLink } from "react-router-dom"
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux"
import actions from "../store/actions"
import Modal from 'react-modal'
import { LoginService } from '../api/api'
import cookie from 'react-cookies'
import { message } from 'antd'
import { withRouter } from 'react-router-dom';

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: '50%',
        bottom: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%,-50%)',


        width: '380px',
        height: '320px',
        overflow: 'hidden',
        border: '1px solid #DFDFDF',
        backgroundColor: '#FFF',
        filter: 'alpha(opacity:50); opacity:0.5;  -moz-opacity:0.5;-khtml-opacity: 0.5'

    },
    overlay: {

        zIndex: '1000'

    }
}
class Nav extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

            isLogin: !!cookie.load('vlec_token'),
            count: 60,
            showLoginModal: false,
            canSend: true
        };
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.sendVerifyCode = this.sendVerifyCode.bind(this);
        this.login = this.login.bind(this);
        this.logOut = this.logOut.bind(this);

    }
    componentWillMount = () => {
       
        // this.getUser((user) => {
        //     if (!user)
        //         user = { NickName: '' };
        //     this.setState({ NickName: user.NickName });
        // })

    }

    logOut() {
        cookie.remove('vlec_token');
        window.location.reload();
    }
    componentWillUnmount = () => {
        console.log('删除定时器');
        clearInterval(this.timer);
    }

    toLogin() {
        console.log('log');
        this.setState({ showLoginModal: true })
    };
    afterOpenModal() {

        // this.subtitle.style.color='#f00';
    };

    closeModal() {

        this.setState({ showLoginModal: false })
    };
    // getUser(callback) {
    //     let token = cookie.load('vlec_token')
    //     var userstr = window.sessionStorage.getItem(token);
    //     if (userstr) {
    //         callback(JSON.parse(userstr));
    //     } else {
    //         LoginService.GetUser().then((data) => {
    //             var result = data.DataResult;
    //             if (result) {
    //                 window.sessionStorage.setItem(token, JSON.stringify(result));
    //                 callback(result);
    //             } else {
    //                 callback(null);

    //             }
    //         });
    //     }
    // }
    /*  */
    sendVerifyCode(e) {
        e.preventDefault();
        if (!this.refs.mobile.value) {

            message.error(this.props.local === 'en' ? 'please input mobile' : '请输入手机号', 2);
            return;
        }
        this.setState({
            canSend: false,
            count: 60


        });
        let count = this.state.count;
        this.timer = setInterval(() => {
            //
            if (count === 0) {
                clearInterval(this.timer);
                this.setState({ canSend: true, count: 60 });

            }
            this.setState({
                count: (count--),


            });

        }, 1000);


        //  e.persist();

        // e.target.disabled=true;
        LoginService.SendVerifyCode({ mobile: this.refs.mobile.value }).then((result) => {
            //    console.log(result);
            //    console.log('2');
            //    clearInterval(this.timer);
            //    this.setState({canSend:true,count:60});
            message.success('send success', 1);
            //  e.target.disabled=false;
        }, (response) => {
            message.error('send error', 2);
            clearInterval(this.timer);
            this.setState({ canSend: true, count: 60 });
            // e.target.disabled=false;
        });

    }
    login() {
        // cookie.save("vlec_token","test",{path:'/',maxAge:new Date().setDate(new Date().getDate()+7)});
        // return;

        LoginService.Login({ mobile: this.refs.mobile.value, verifyCode: this.refs.verifyCode.value }).then(result => {
            if (result && result.DataResult.Token) {
                var expire = new Date().setDate(new Date().getDate() + 7);
                cookie.save("vlec_token", result.DataResult.Token, { path: '/', maxAge: expire });
                this.closeModal();
                window.location.reload();
            } else {
                // message.destory();
                message.error(this.props.local === "en" ? "login error" : "登录失败", 1);


                //登录失败
            }

        });
    }

    render() {
      let centerActive=  this.props.location.pathname=='/shcenter'||this.props.location.pathname=='/Center';
      let aboutActive=this.props.location.pathname=='/AboutUs';
      let shaboutActive=this.props.location.pathname=='/shaboutus';
        /*      let userTag=
             (this.state.isLogin?(<ul className="nav-ul"><li><h3><FormattedMessage id="user-hello"/>{this.state.NickName}</h3> </li><li><a onClick={this.logOut}><FormattedMessage
             id="intl-Nav-Logout"
         /></a></li></ul>):(<ul className="nav-ul"><li onClick={this.toLogin.bind(this)}>
             <a > <FormattedMessage
                 id="intl-Nav-Login"
             /></a>
         </li></ul>)); */
        return (<div>
            <div className="navDiv">
                <div className="navLogo"> <NavLink to="/Home">
                </NavLink></div>

                {/*   {userTag} */}

                <div className="icoEN">
                    <i className="icon-languageZ" style={{ fontStyle: "normal" }}
                        onClick={this.props.changeLanguage}> {this.props.local === "en" ? "CN" : "EN"}</i>
                </div>
                <ul className="nav-ul nav-login">
                    <li  className="nav-home">
                        <NavLink to="/Home">
                            <FormattedMessage
                                id="intl-Nav-Home"
                            /></NavLink>
                    </li>
                    <li className="menu nav-InnovationCenter">

                        <a className={centerActive?'active':''}>
                            <FormattedMessage
                                id="intl-Nav-Center"
                            /></a>
                        <ul className="sub-menu">
                            <li className="nav-InnovationCenter"> <NavLink to="/Center">
                                <FormattedMessage
                                    id="intl-area-bj"
                                /></NavLink></li>
                            <li className="nav-InnovationCenter">
                                <NavLink to="/shcenter">
                                    <FormattedMessage
                                        id="intl-area-sh"
                                    /></NavLink>
                            </li>
                            <li className="nav-InnovationCenter">
                                <NavLink to="/szcenter">
                                    <FormattedMessage
                                        id="intl-area-sz"
                                    /></NavLink>
                            </li>
                            <li className="nav-InnovationCenter">
                                <NavLink to="/tjcenter">
                                    <FormattedMessage
                                        id="intl-area-tj"
                                    /></NavLink>
                            </li>
                            {/* <li className="nav-InnovationCenter">
                                <NavLink to="/tjltzngccenter">
                                    <FormattedMessage
                                        id="intl-area-tjltzngc"
                                    /></NavLink>
                            </li> */}
                        </ul>
                    </li>
                    <li className="nav-Activities">

                        <a onClick={this.props.clickGroup} className={this.props.location.pathname==='/Group'?'active':''} >

                            <FormattedMessage
                                id="intl-Nav-GroupApply"
                            /></a>
                    </li>
                    <li className="nav-intlActivities">
                        {/* <a  onClick={()=>window.open('https://mp.weixin.qq.com/s/8hnpMbLUd1x8thAXHdqiCw')} className="nav-intlActivities">
                                <FormattedMessage id="intl-Nav-Activities"/>
                            </a> */}
                        <NavLink to="/Event" >

                            <FormattedMessage
                                id="intl-Nav-Activities"
                            /></NavLink>
                    </li>

                    <li className="menu nav-AboutUs">
                        <a  className={aboutActive?'active':shaboutActive?'shactive':''}>
                            <FormattedMessage
                                id="intl-Nav-AboutUs"
                            /></a>
                        <ul className="sub-menu">
                            <li className="nav-AboutUs"> <NavLink to="/AboutUs">
                                <FormattedMessage
                                    id="intl-area-bj"
                                /></NavLink></li>
                            <li className="nav-shAboutUs">
                                <NavLink to="/shaboutus" >
                                    <FormattedMessage
                                        id="intl-area-sh"
                                    /></NavLink>
                            </li>
                            <li className="nav-szAboutUs">
                                <NavLink to="/szaboutus" >
                                    <FormattedMessage
                                        id="intl-area-sz"
                                    /></NavLink>
                            </li>
                            <li className="nav-szAboutUs">
                                <NavLink to="/tjaboutus">
                                    <FormattedMessage
                                        id="intl-area-tj"
                                    /></NavLink>
                            </li>
                        </ul>
                    </li>
                    <li className="nav-News">
                        <NavLink to="/News">
                            <FormattedMessage
                                id="intl-Nav-News"
                            /></NavLink>
                    </li>
                </ul>

            </div>
            <div style={{ width: "100%", height: "83px" }}></div>
            <div id="loginModal"></div>
            <Modal
                isOpen={this.state.showLoginModal}
                appElement={document.getElementById('loginModal')}
                ariaHideApp={false}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyle}

                contentLabel=" Login "
            >

                {/* <button onClick={this.closeModal}>close</button> */}

                <div className="login_Div">
                    <div className="close_top"><a onClick={this.closeModal} className="close">X</a></div>
                    <div className="login_top"></div>
                    <div className="big_box">
                        <input type="text" ref="mobile" className="text_box mbt_20" placeholder={this.props.local === "en" ? 'please input mobile' : "请输入手机号"} />
                        <input type="text" ref="verifyCode" className="text_box text_yzm mbt_20" placeholder={this.props.local === "en" ? 'verify code' : "验证码"} />
                        {this.state.canSend ? <button onClick={this.sendVerifyCode} className="btn_yzm mbt_20"><FormattedMessage id="send-verifycode" /></button> : <button className="btn_yzm mbt_20"><span>{this.state.count}S</span></button>}
                        <div className="mtt_10">
                            <button onClick={this.login} className="btn_login"><FormattedMessage id="intl-Nav-Login" /></button>
                        </div>
                    </div>

                </div>


            </Modal>
        </div>



        )
    }
}

export default withRouter(connect(state => ({ ...state.Language }), actions.Language)(Nav))



// WEBPACK FOOTER //
// ./src/component/Nav.js